export interface GenericLead {
  property_type:
    | "residential"
    | "business"
    | "enterprise"
    | "wholesale"
    | "business_account"
    | "residential_health_check"
    | "business_health_check";
  contact_name?: string;
  first_name?: string;
  last_name?: string;
  phone_number: string;
  email_address: string;
  lead_url?: string;
  lead_source?: string;
  locid?: string;
  addressid?: string;
  ad_click_provider?: string;
  ad_click_id?: string;
  business_name?: string;
  abn?: string;
  notes?: string;
  IREFERRER?: string;
  LREFERRER?: string;
  ILANDPAGE?: string;
  referrer_raw?: string;
  interests?: string | string[];
  lead_priority?: number;
  time_to_call?: string;
  preferred_call_time?: string;
  callback_date?: string;
  number_of_employees?: string;
  state?: string;
  existing_customer?: boolean;
}

export enum LeadMethod {
  ADDRESS_CHECK = "NBN Availability",
  AUSSIE_FIBRE = "Aussie Fibre Availability",
  BUSINESS_COMPETITION = "Business Competition",
  BUSINESS_QUOTE = "Business Quote Form",
  BUSINESS_ACCOUNTS = "Business Success Team",
  COMPLAINT = "Lodge a Complaint",
  CONTACT_US = "Contact Us",
  COMPETITION = "competition", // Won't go into a call queue
  EBOOK_DOWNLOAD = "Ebook Download",
  ENTERPRISE_EVENT = "Enterprise Event Form",
  ENTERPRISE_QUOTE = "Enterprise Quote Form",
  NBN_EE_AVAILABILITY = "NBN EE Availability",
  FIBRE_CONNECT = "Fibre Connect",
  FIBRE_CONNECT_RENTERS = "Fibre Connect Renters",
  MANAGED_SERVICES = "Managed Services Form",
  MOBILE_HANDSET_LEAD_GEN = "Mobile Handset Interest Form",
  MOBILE_SIM_LEAD_GEN = "Mobile SIM Interest Form",
  PARTNER_PROGRAM = "Partner Program",
  VOICE_BUILDER = "Voice Plan Builder",
  WHOLESALE_FORM = "Wholesale Contact Form",
  CARBON = "Carbon Access",
}

// export enum LeadPriority {
//   AUSSIE_FIBRE_AVAILABLE = 30, // Aussie Fibre SQ – in range of fibre lines
//   AUSSIE_FIBRE_UNAVAILABLE = 60, // Aussie Fibre SQ – outside range of fibre lines
//   CART_ABANDONMENT = 10, // Cart Abandonment
//   CONTACT_US = 20, // Get a quote, contact us
//   ADDRESS_CHECK = 30, // Availability forms
//   INFORMATION_CHECK = 46, // Brochure forms etc.
//   UPSELL = 60, // Fibre upgrade checks when address is not eligible
//   FTTP_ELIGIBLE = 30, // FTTP upgrade eligible
//   FTTP_HFC_ACTIVE = 35, // FTTP or  HFC active
//   FTTP_AVAILABLE_SOON = 45, // FTTP available soon - when RTC
//   FTTP_NOT_ELIGIBLE = 60, // FTTP upgrade not eligible
//   BUSINESS_ACCOUNTS = 82, // Business Success Team
// }

export const LeadPriority = {
  AUSSIE_FIBRE_AVAILABLE: 30, // Aussie Fibre SQ – in range of fibre lines
  AUSSIE_FIBRE_UNAVAILABLE: 40, // Aussie Fibre SQ – outside range of fibre lines
  CART_ABANDONMENT: 10, // Cart Abandonment
  CONTACT_US: 20, // Get a quote, contact us
  ADDRESS_CHECK: 30, // Availability forms
  INFORMATION_CHECK: 46, // Brochure forms etc.
  UPSELL: 60, // Fibre upgrade checks when address is not eligible
  FTTP_ELIGIBLE: 30, // FTTP upgrade eligible
  FTTP_HFC_ACTIVE: 35, // FTTP or  HFC active
  FTTP_AVAILABLE_SOON: 45, // FTTP available soon - when RTC
  FTTP_NOT_ELIGIBLE: 60, // FTTP upgrade not eligible
  BUSINESS_ACCOUNTS: 82, // Business Success Team
} as const;
